<style scoped>
.checkin {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  padding: 16px 20px;
  box-sizing: border-box;
  background: #f4f7fc;
}
.checkin_title {
  font-size: 14px;
  color: #b2b2b2;
  margin-bottom: 16px;
}
.checkin_title span {
  color: #5c5c5c;
}
.checkin_information {
  width: 100%;
  flex: 1;
  background: white;
  display: flex;
  flex-direction: column;
  border-radius: 4px;
  box-shadow: 0px 1px 4px 1px rgba(21, 34, 50, 0.08);
  border-radius: 6px 6px 6px 6px;
  box-sizing: border-box;
}
.checkin_information::-webkit-scrollbar {
  display: none;
}
.checkin_information_t {
  font-size: 16px;
  color: #1a1a1a;
  margin-bottom: 24px;
}
.member_header {
  width: 100%;
  height: 76px;
  border-bottom: 1px solid #cfd4e8;
  display: flex;
  align-items: center;
  padding: 0 19px;
  box-sizing: border-box;
  justify-content: flex-end;
}
.member_header_bto {
  margin-left: 16px;
  cursor: pointer;
  height: 36px;
  border-radius: 4px 4px 4px 4px;
  border: 1px solid #d5d7e3;
  margin-left: 6px;
  text-align: center;
  padding: 0 12px;
  box-sizing: border-box;
  line-height: 36px;
  font-size: 14px;
  color: #7e84a3;
}
.member_content {
  display: flex;
  flex: 1;
  width: 100%;
}
.member_content_l {
  width: 330px;
  height: 100%;
  display: flex;
  flex-direction: column;
  padding: 20px 0 20px;
  border-right: 1px solid #cfd4e8;
  box-sizing: border-box;
}
.member_content_search {
  display: flex;
  align-items: center;
  padding: 0 20px;
  box-sizing: border-box;
  justify-content: space-between;
  flex-wrap: wrap;
}
.de_search_name {
  width: 290px !important;
  margin-right: 10px;
}

.de_search {
  width: 243px;
  height: 40px;
  border-radius: 4px;
  margin-bottom: 16px;
  border: 1px solid #d0d0d0;
  display: flex;
  align-items: center;
  padding-right: 12px;
  box-sizing: border-box;
  justify-content: space-between;
}
::v-deep .member_content_search .el-select {
  width: 140px;
  margin-bottom: 16px;
}
.member_content_device {
  width: 100%;
  flex: 1;
  overflow-y: scroll;
}
.member_content_device::-webkit-scrollbar {
  display: none;
}
.member_content_d {
  width: 100%;
  height: 48px;
  padding: 0 40px;
  line-height: 48px;
  box-sizing: border-box;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  color: #5c5c5c;
  font-size: 16px;
  position: relative;
  cursor: pointer;
}
.member_content_d_online::after {
  content: "";
  position: absolute;
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: #1fc700;
  top: 50%;
  transform: translateY(-50%);
  left: 24px;
}
.member_content_d_offline::after {
  content: "";
  position: absolute;
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: #fd1d1d;
  top: 50%;
  transform: translateY(-50%);
  left: 24px;
}
.member_content_d_select {
  background: #f2f7ff;
}
.member_content_r {
  flex: 1;
  height: 100%;
  display: flex;
  flex-direction: column;
  padding: 0 33px 0 44px;
  box-sizing: border-box;
}
.member_content_r_search {
  width: 100%;
  height: 86px;
  display: flex;
  padding-top: 20px;
  box-sizing: border-box;
}
::v-deep .member_content_r_search .el-select {
  width: 137px;
  margin: 0 12px;
}
::v-deep .member_content_r_search .el-input__icon {
  height: auto;
}
::v-deep .member_content_r_search .el-date-editor.el-input,
.el-date-editor.el-input__inner {
  width: 137px;
  height: 36px;
  margin-right: 12px;
}
.memeber_table {
  width: 100%;
  flex: 1;
  position: relative;
}
.member_name {
  display: flex;
  align-items: center;
  font-size: 16px;
  color: #1a1a1a;
}
.member_head {
  width: 30px;
  height: 30px;
  object-fit: cover;
  border-radius: 50%;
  margin-right: 10px;
}
.m_table {
  width: 100%;
  height: 41rem;
  position: absolute;
}
.online_detection {
  width: 100px;
  height: 40px;
  background: #eaeaea;
  border-radius: 4px 4px 4px 4px;
  border: 1px solid #d5d7e3;
  color: #1a1a1a;
  font-size: 15px;
  line-height: 40px;
  text-align: center;
  margin: 0 auto;
  cursor: pointer;
}
.diglog_h {
  display: flex;
  box-sizing: border-box;
  align-items: center;
  justify-content: space-between;
  font-size: 18px;
  padding: 24px;
  border-bottom: 1px solid #cfd4e8;
  color: #1a1a1a;
}

.diglog_icon {
  width: 24px;
  height: 24px;
  cursor: pointer;
}
.available_frame {
  width: 850px;
  height: 486px;
  border-radius: 4px 4px 4px 4px;
  border: 1px solid #d0d0d0;
  margin: 30px auto;
  display: flex;
}
.available_frame_left {
  width: 346px;
  height: 100%;
  border-right: 1px solid #d0d0d0;
}
.available_title {
  width: 100%;
  height: 45px;
  background: #ededed;
  padding-left: 20px;
  box-sizing: border-box;
  line-height: 45px;
  color: #1a1a1a;
  border-radius: 3px 0px 0px 0px;
}
.available_frame_center {
  width: 260px;
  height: 100%;
  border-right: 1px solid #d0d0d0;
}
.available_frame_right {
  flex: 1;
  height: 100%;
}
.available_search {
  width: 307px;
  margin: 15px auto 0;
  height: 36px;
  background: #ffffff;
  border-radius: 4px 4px 4px 4px;
  border: 1px solid #d0d0d0;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding-right: 16px;
  box-sizing: border-box;
}
.available_search_icon {
  width: 18px;
  height: 18px;
  cursor: pointer;
}
.available_search_input {
  height: 98%;
}
::v-deep .available_search .el-input__inner {
  height: 100%;
  border: none;
}
.available_depa {
  width: 100%;
  height: 56px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 20px;
  box-sizing: border-box;
  cursor: pointer;
}
.available_depa_left {
  display: flex;
  align-items: center;
  font-size: 16px;
  color: #1a1a1a;
}
.available_depa_left_icon {
  width: 36px;
  height: 36px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #cbe7ff;
  margin-right: 10px;
}
.available_depa_left_icon2 {
  width: 36px;
  height: 36px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #cbe7ff;
  margin: 0 8px 0 0;
}
.available_depa_left_icon img {
  width: 18px;
  height: 18px;
}
.available_depa_left_icon2 img {
  width: 18px;
  height: 18px;
}
.available_depa_left_next {
  color: #0058ff;
  font-size: 15px;
  cursor: pointer;
}
.available_frame_tobeselected {
  margin-top: 12px;
}
.available_frame_tobeselected_top {
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 14px;
  color: rgba(26, 26, 26, 0.6);
  padding: 0 12px;
  box-sizing: border-box;
}
.available_frame_tobeselected_delte {
  font-size: 14px;
  color: rgba(236, 54, 54, 0.9);
  text-align: right;
  cursor: pointer;
}
::v-deep .available_frame_tobeselected_top .el-checkbox__label {
  font-size: 14px;
  color: rgba(26, 26, 26, 0.6);
  font-weight: normal;
}
.available_frame_tobeselected_center {
  margin-top: 15px;
  height: 390px;
  overflow-y: scroll;
}
.available_frame_tobeselected_center::-webkit-scrollbar {
  display: none;
}
.available_frame_tobeselected_single {
  display: flex;
  height: 56px;
  align-items: center;
  padding: 0 20px;
  box-sizing: border-box;
}
.available_frame_tobeselected_single2 {
  display: flex;
  height: 56px;
  align-items: center;
  justify-content: space-between;
  padding: 0 20px;
  box-sizing: border-box;
}
.available_frame_tobeselected_name {
  font-size: 15px;
  color: #1a1a1a;
}
.available_frame_tobeselected_depa {
  font-size: 13px;
  max-width: 100px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  color: rgba(26, 26, 26, 0.6);
}
.available_frame_select_left {
  display: flex;
  align-items: center;
}
.available_frame_select_right {
  width: 16px;
  height: 16px;
  cursor: pointer;
}
::v-deep .workhour_time .el-form-item__content {
  line-height: normal;
}
.register_top {
  width: 100%;
  height: 73px;
  border-bottom: 1px solid #cfd4e8;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 24px;
  font-size: 18px;
  color: #1a1a1a;
  box-sizing: border-box;
}
.register_close {
  width: 24px;
  height: 24px;
  cursor: pointer;
}
.register_center {
  margin-top: 33px;
}
.register_center_name {
  font-size: 16px;
  color: #1a1a1a;
  text-align: center;
}
.register_icon {
  width: 60px;
  height: 60px;
  margin: 21px auto 37px;
  display: block;
}
.register_end {
  width: 100px;
  height: 40px;
  background: #0058ff;
  border-radius: 4px 4px 4px 4px;
  color: white;
  text-align: center;
  line-height: 40px;
  font-size: 15px;
  margin: 0 auto;
  cursor: pointer;
}
.diglog_operation {
  margin: 60px auto 0;
  display: flex;
  align-items: center;
  justify-content: center;
}
.settips {
  margin-top: 30px;
  padding-left: 30px;
  box-sizing: border-box;
  font-size: 16px;
  color: #1a1a1a;
}
.available_depa_select {
  background: #f2f7ff;
}
.breadcrumbs {
  display: flex;
  margin: 20px 0;
  flex-wrap: wrap;
  align-items: center;
  padding-left: 20px;
  box-sizing: border-box;
}
.breadcrumbs_text {
  cursor: pointer;
  max-width: 150px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
.breadcrumbs_current {
  color: #1a1a1a;
}
.breadcrumbs_last {
  color: rgba(26, 26, 26, 0.6);
}
.available_frame_bto {
  display: flex;
  align-items: center;
  justify-content: center;
}
.available_frame_cancel {
  width: 100px;
  height: 40px;
  border-radius: 4px 4px 4px 4px;
  border: 1px solid #d5d7e3;
  font-size: 15px;
  color: #7e84a3;
  margin-right: 30px;
  text-align: center;
  line-height: 40px;
  cursor: pointer;
}
.available_frame_comfin {
  width: 100px;
  height: 40px;
  background: #0058ff;
  border-radius: 4px 4px 4px 4px;
  font-size: 15px;
  color: white;
  text-align: center;
  cursor: pointer;
}
.available_depa_left_name {
  max-width: 230px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
.breadcrumbs_all {
  display: flex;
  align-items: center;
}
.structure_feature {
  display: flex;
  align-items: center;
}
.feature {
  width: 30px;
  height: 30px;
  margin-right: 12px;
}
::v-deep .available_search .el-select {
  width: 120px;
  border-right: 1px solid #d0d0d0;
}
.ellipsis {
  width: 130px;
  white-space: nowrap; /* 防止文本换行 */
  overflow: hidden; /* 隐藏超出容器的文本 */
  text-overflow: ellipsis; /* 显示省略号表示文本被截断 */
}
.fp_list {
  display: flex;
  width: 100%;
  height: 203px;
  align-items: center;
  justify-content: center;
}
.fp_single {
  width: 98px;
  height: 138px;
  background: rgba(0, 137, 255, 0.07);
  border-radius: 4px 4px 4px 4px;
}
.fp_single:nth-child(2) {
  margin: 0 73px;
}
.fp_single {
  display: flex;
  position: relative;
  flex-direction: column;
}
.fp_single_top {
  height: 98px;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  border-bottom: 1px solid rgba(0, 135, 252, 0.14);
}
.fp_single_add {
  width: 38px;
  height: 38px;
  cursor: pointer;
}
.fp_single_text {
  flex: 1;
  line-height: 40px;
  width: 100%;
  text-align: center;
  font-size: 16px;
}
.offline {
  position: relative;
}
.offline::after {
  position: absolute;
  content: "";
  top: 50%;
  transform: translateY(-50%);
  left: 24px;
  width: 8px;
  height: 8px;
  background: #ff0000;
  border-radius: 50%;
}
.online {
  position: relative;
}
.online::after {
  position: absolute;
  content: "";
  top: 50%;
  transform: translateY(-50%);
  left: 24px;
  width: 8px;
  height: 8px;
  background: #1ab137;
  border-radius: 50%;
}
.fp_single_icon {
  width: 58px;
  height: 58px;
}
.available_depaall {
  height: 20rem;
  overflow-y: scroll;
}
.available_depaall::-webkit-scrollbar {
  display: none;
}
.deleteFp {
  position: absolute;
  top: -5px;
  right: -5px;
  width: 20px;
  height: 20px;
  cursor: pointer;
}
.newpagination {
  height: 50px;
  margin-top: 10px;
}
.dynamic-data-container{
  display: flex;
  justify-content: center; /* 水平居中 */
  align-items: center;     /* 垂直居中（可选） */
  font-size: 18px;
  color: #0d94dd;
}
.dynamic-data-item{
  border: 1px solid #85D2FC;
  border-radius: 6px;
  width: 160px;
  height: 160px;
  background: rgba(133, 210, 252, 0.3);
  margin: 30px 30px 0px 30px;
  display: grid;
  place-items: center; /* 同时水平和垂直居中 */
  cursor: pointer;
}

.feature-image{
  width: 70px;
  height: 70px;
}
.feature-text{
  text-align: center;
  height: 40px;
  width: 100%;
}
</style>

<template>
  <!-- 可用人员范围 -->
  <el-dialog
      title=""
      :visible.sync="availableDialog"
      width="890px"
      :show-close="false"
      :close-on-click-modal="false"
      append-to-body
  >
    <div class="diglog_h">
      <div>选择人员</div>
      <img
          src="@/assets/structure/close.png"
          class="diglog_icon"
          @click="closeavailableDialog"
      />
    </div>
    <div class="available_frame">
      <div class="available_frame_left">
        <div class="available_title">部门/人员</div>
        <div class="available_search">
          <el-select v-model="selectType" placeholder="请选择">
            <el-option
                v-for="item in options"
                :key="item.value"
                :label="item.label"
                :value="item.value"
            >
            </el-option>
          </el-select>
          <el-input
              v-model="searchValue"
              @keyup.enter.native="searchAvailable"
              class="available_search_input"
              :placeholder="selectType == 1 ? '部门名称' : '员工姓名'"
          >
          </el-input>
          <img
              src="@/assets/structure/search.png"
              class="available_search_icon"
              @click="searchAvailable"
          />
        </div>
        <div>
          <div class="breadcrumbs">
            <div
                v-for="(item, index) in breadcrumbs"
                :key="index"
                class="breadcrumbs_all"
                @click="clickBreadcrumbs(index, item)"
            >
              <div
                  :class="[
                    'breadcrumbs_text',
                    index == breadcrumbs.length - 1
                      ? 'breadcrumbs_current'
                      : 'breadcrumbs_last',
                  ]"
              >
                {{ item.name }}
              </div>
              <div style="margin: 0 5px">
                {{ index == breadcrumbs.length - 1 ? " " : "/" }}
              </div>
            </div>
          </div>
          <div class="available_depaall">
            <div
                :class="[
                  'available_depa',
                  availableSelecDept == item.id ? 'available_depa_select' : '',
                ]"
                v-for="(item, index) in availableDept"
                @click="switchDpat(item)"
                :key="index"
            >
              <div class="available_depa_left">
                <div class="available_depa_left_icon">
                  <img src="@/assets/device.png"/>
                </div>
                <div class="available_depa_left_name">{{ item.name }}</div>
              </div>
              <div
                  v-if="item.subDepartment"
                  class="available_depa_left_next"
                  @click="checkSubordinate(item)"
              >
                下级
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="available_frame_center">
        <div class="available_title">待选择人员</div>
        <div class="available_frame_tobeselected">
          <div class="available_frame_tobeselected_top">
            <el-checkbox @change="selectAllpeople" v-model="isSelecAll"
            >全选
            </el-checkbox
            >
            <div>
              已选：{{
                countCommonValues(waitPeopleList, completePeopleList)
              }}
            </div>
          </div>
          <el-checkbox-group v-model="completePeopleList">

            <virtual-list style="height: 25rem; overflow-y: auto;margin-top: 10px;"
                          :data-key="'id'"
                          :data-sources="waitPeopleList"
                          :data-component="memberUnselectedItemComponent"/>
          </el-checkbox-group>
        </div>
      </div>
      <div class="available_frame_right">
        <div class="available_title">已选择人员</div>
        <div class="available_frame_tobeselected">
          <div class="available_frame_tobeselected_top">
            <div class="available_frame_tobeselected_delte" @click="deleteAll">
              全部移除
            </div>
            <div>
              已选：{{ completePeopleList.length }}
            </div>
          </div>
          <virtual-list style="height: 25rem; overflow-y: auto;margin-top: 10px;"
                        :data-key="'id'"
                        :data-sources="completePeopleList"
                        :data-component="memberSelectedItemComponent"
                        :extra-props="{deleteSelect}"
          />
        </div>
      </div>
    </div>
    <div class="available_frame_bto">
      <div class="available_frame_cancel" @click="closeavailableDialog">
        取消
      </div>
      <el-button
          class="available_frame_comfin"
          @click="handleComfin"
          v-loading="loading"
      >确定
      </el-button
      >
    </div>
  </el-dialog>
</template>


<script>
import VirtualList from 'vue-virtual-scroll-list';
import MemberUnselectedItem from "@/views/attendance/register/dialog/components/MemberUnselectedItem.vue";
import MemberSelectedItem from "@/views/attendance/register/dialog/components/MemberSelectedItem.vue";
import http from "@/utils/http";
export default {
  components: {
    VirtualList
  },
  data() {
    return {
      memberUnselectedItemComponent: MemberUnselectedItem,
      memberSelectedItemComponent: MemberSelectedItem,
      availableDialog: false,
      loading: false,
      waitPeopleList: [], //待选人员
      completePeopleList: [], //已选人员
      isSelecAll: false, //是否全选
      breadcrumbs: [], //面包屑
      availableDept: [], //部门列表
      availableDeptCopy: [], //复制部门列表
      availableSelecDept: null, //所选部门id
      searchValue: "", //搜索关键词
      selectType: 1, //搜索选择类型
      options: [
        {
          label: "部门",
          value: 1,
        },
        {
          label: "人员",
          value: 2,
        },
      ],
    };
  },
  watch: {
    completePeopleList: {
      handler(newValue, oldValue) {
        if (this.waitPeopleList.length > 0) {
          var filteredArr = this.waitPeopleList.filter(function (item) {
            return !item.isIn;
          });
          // 当 items 数组发生变化时，这个函数会被调用
          let containsAll = filteredArr.every((value) =>
              newValue.includes(value)
          );
          // 你可以在这里执行你想要的操作
          if (containsAll) {
            this.isSelecAll = true;
          } else {
            this.isSelecAll = false;
          }

          var isrepeat = this.hasDuplicates(newValue);
          if (isrepeat) {
            var arr = this.removeDuplicates(newValue);

            this.completePeopleList = arr;
          }
        }
      },
      deep: true, // 深度监听，用于监听数组内部对象的变化
    },
    // 监听待选择列表
    waitPeopleList: {
      handler(newValue, oldValue) {
        this.completePeopleList.map((item) => {
          var index = newValue.findIndex((citem) => item.id == citem.id);
          if (index > -1) {
            this.$set(newValue[index], "checked", true);
          }
        });
      },
      deep: true, // 深度监听，用于监听数组内部对象的变化
    },
    // 监听设备sn变化
    deviceIds(newValue, oldValue) {
      if (newValue) {
        var value = this.deviceList.find((item) => item.id == newValue);
        this.deviceForm = value;
        if (value) {
          var type = value.sn.startsWith("NP", 0);
          if (!type) {
            this.isShowFingerprint = true;
          } else {
            this.isShowFingerprint = false;
          }
        }
      }
    },
    // 监听输入框变化
    searchValue(newValue, oldValue) {
      if (!newValue) {
        this.breadcrumbs = [];
        this.availableDept = this.availableDeptCopy;
        this.waitPeopleList = [];
      }
    },

  },
  created() {

  },
  mounted() {

  },
  methods: {
    show(list = []){
      this.completePeopleList = [...list];
      this.availableDialog = true;
      this.getDepartmentList();
    },
    closeavailableDialog() {
      this.completePeopleList = [];
      this.breadcrumbs = [];
      this.availableDept = this.availableDeptCopy;
      this.isSelecAll = false;
      this.waitPeopleList = [];
      this.availableDialog = false;
    },
    // 判断数组是否有重复
    hasDuplicates(array) {
      const set = new Set();
      for (let item of array) {
        if (set.has(item.id)) {
          return true; // 如果集合中已经存在该元素，则说明有重复
        }
        set.add(item.id); // 否则将元素添加到集合中
      }
      return false; // 遍历完数组后仍未发现重复项
    },
    // 数组去重
    removeDuplicates(array) {
      // 使用 Map 来去重，Map 的键是 id，值是对象本身
      const map = new Map();

      for (let item of array) {
        map.set(item.id, item); // 如果 id 已经存在，则会覆盖
      }

      // 将 Map 的值转换回数组
      return Array.from(map.values());
    },
    // 获取部门列表
    getDepartmentList() {
      http.get("/umsDepartment/list").then((res) => {
        if (res.code == 200) {
          var arr = this.convertToNestedStructure(res.data);
          this.availableDept = arr;
          this.availableDeptCopy = JSON.stringify(arr);
          this.availableDeptCopy = JSON.parse(this.availableDeptCopy);
        }
      });
    },
    // 递归处理数据
    convertToNestedStructure(arr) {
      // 创建一个映射，用于快速查找具有特定id的对象
      const idMap = new Map(arr.map((item) => [item.id, item]));

      // 创建一个新数组来存储转换后的嵌套结构
      const nestedArr = [];

      // 遍历原始数组
      arr.forEach((item) => {
        // 如果该项有父元素，则将其添加到父元素的subDepartment数组中
        if (item.parent) {
          const parent = idMap.get(item.parent);
          if (parent) {
            if (!parent.subDepartment) {
              parent.subDepartment = [];
            }
            item.parentDepament = parent.name;
            parent.subDepartment.push(item);
          }
        } else {
          // 如果没有父元素，则添加到新数组的根级别
          nestedArr.push(item);
        }
      });

      // 返回转换后的嵌套数组
      return nestedArr;
    },
    searchAvailable() {
      if (this.selectType == 1) {
        // 搜索部门
        let result = this.findNode(this.searchValue);
        if (result) {
          this.availableDept = [...result];
        } else {
          this.availableDept = [];
        }
      } else {
        // 搜索人
        http
            .get("/umsUser/queryUmsUserSimpleList", {
              likeString: this.searchValue,
            })
            .then((res) => {
              if (res.code == 200) {
                this.waitPeopleList = res.data;
              }
            });
      }
    },
    // 搜索指定的值
    findNode(target) {
      let stack = [...this.availableDeptCopy]; // 初始化栈为顶层数组的元素
      let nodes = [];
      while (stack.length > 0) {
        let node = stack.pop(); // 弹出栈顶元素

        if (node.name.indexOf(target)>=0) {
          nodes.push(node);
          //return node; // 找到目标节点，返回
          continue;
        }

        if (node.subDepartment) {
          stack.push(...node.subDepartment); // 将子节点压入栈中
        }
      }

      return nodes; // 未找到目标节点
    },
    // 点击面包屑的部门
    clickBreadcrumbs(index, item) {
      this.breadcrumbs.splice(index + 1);
      var arr = this.searchNestedObject(this.availableDeptCopy, item.id);
      this.getDept(item.id, item.name);
      this.availableDept = arr.subDepartment;
    },
    // 查询子级
    searchNestedObject(arr, id) {
      for (let i = 0; i < arr.length; i++) {
        if (arr[i].id === id) {
          return arr[i];
        }
        if (arr[i].subDepartment) {
          const found = this.searchNestedObject(arr[i].subDepartment, id);
          if (found) {
            return found;
          }
        }
      }
      return undefined;
    },
    // 获取部门列表
    getDept(id, department) {
      const loading = this.$loading({
        lock: true,
        text: '正在获取部门用户列表',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      });
      http
          .get("/umsUser/queryUmsUserSimpleList", {
            deptId: id
          })
          .then((res) => {
            if (res.code == 200) {
              var arr = [];
              res.data.map((item) => {
                item.department = department;
                item.checked = false;
                arr.push(item);
              });
              this.waitPeopleList = arr;

              if (arr.length > 0) {
                var istrue = this.areAllIdsInArray(arr, this.completePeopleList);
                if (istrue) {
                  this.isSelecAll = true;
                } else {
                  this.isSelecAll = false;
                }
              }

            }
            loading.close();
          }).catch(() => {
        loading.close();
      });
    },
    // 判断有几个已经选择
    countCommonValues(array1, array2) {
      // 将 array1 的 id 存储在一个集合中
      const set1 = new Set(array1.map((item) => item.id));

      // 计数器
      let commonCount = 0;

      // 遍历 array2 并检查每个 id 是否存在于集合中
      for (let item of array2) {
        if (set1.has(item.id)) {
          commonCount++;
        }
      }

      return commonCount;
    },
    // 判断待选择是否都在已选择里面
    areAllIdsInArray(a, b) {
      // 将 b 的 id 存储在一个集合中
      const setB = new Set(b.map((item) => item.id));

      // 检查 a 中的每个 id 是否都在集合 setB 中
      for (let item of a) {
        if (!setB.has(item.id)) {
          return false; // 如果有一个 id 不在 b 中，则返回 false
        }
      }

      return true; // 如果所有 id 都在 b 中，则返回 true
    },
    // 全选人员
    selectAllpeople(value) {
      if (value) {
        var filteredArr = this.waitPeopleList.filter(function (item) {
          return !item.isIn;
        });
        // 合并两个数组
        let combinedArray = this.completePeopleList.concat(filteredArr);

        // 使用 filter 方法去重
        let uniqueArray = combinedArray.filter((value, index, self) => {
          return self.indexOf(value) === index;
        });
        this.completePeopleList = uniqueArray;
      } else {
        let result = this.completePeopleList.filter(
            (item) => !this.waitPeopleList.includes(item)
        );
        this.completePeopleList = result;
      }
    },
// 切换部门
    switchDpat(item) {
      this.availableSelecDept = item.id;
      this.getDept(item.id, item.name);
    },
    // 删除选中的人员
    deleteSelect(index) {
      this.completePeopleList.splice(index, 1);
    },
    // 删除全部选中的人员
    deleteAll() {
      this.completePeopleList = [];
    },
    // 查看下级部门
    checkSubordinate(item) {
      this.breadcrumbs.push({
        name: item.name,
        id: item.id,
      });

      this.getDept(item.id, item.name);
      this.availableDept = item.subDepartment;
    },
    handleComfin(){
      if (this.completePeopleList.length == 0) {
        this.$message.error("请先选择人员");
        return;
      }
      this.$emit('selected',this.completePeopleList);
      this.availableDialog = false;
    }
  }
};
</script>